<mat-toolbar color="primary" style="height: 45px; padding: 0px 0px 0px 16px">
	<h3 class="title">Filter {{ title }}</h3>
	<span fxFlex></span>
	<div class="action-buttons">
		<button [disableRipple]="true" mat-icon-button (click)="dialogRef.close()">
			<mat-icon>cancel</mat-icon>
		</button>
	</div>
</mat-toolbar>
<div class="advanced-filters">
	<div class="filter-item" *ngFor="let filter of filters; let i = index; trackBy: trackByFn">
		<div class="container" *ngIf="filter.parameter.key !== 'user'">
			<!-- column select -->
			<mat-form-field class="filter" appearance="outline">
				<mat-label>Where</mat-label>
				<mat-select placeholder="Select where" (selectionChange)="onColumnChange($event.value, i)" [value]="filter.parameter.key">
					<mat-option *ngFor="let column of filterColumns" [disabled]="column.disabled" [value]="column.key">
						{{ column.text }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!-- nested filter key select -->
			<mat-form-field class="filter" appearance="outline" *ngIf="!isColumnEmpty(i) && !isNestedColumnEmpty(filter.parameter.key)">
				<mat-label>Column Nested</mat-label>
				<mat-select placeholder="Select property" (selectionChange)="onNestedColumnChange($event.value, i)" [value]="filter.parameter.nestedKey">
					<mat-option *ngFor="let nestedKey of getNestedColumnOptions(filter.parameter.key)" [value]="nestedKey.key">
						{{ nestedKey.text }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!-- condition select -->
			<mat-form-field class="filter" appearance="outline" *ngIf="!isColumnEmpty(i)">
				<mat-label>Condition</mat-label>
				<mat-select placeholder="Select condition" (selectionChange)="onConditionChange($event.value, i)" [value]="filter.condition">
					<mat-option *ngFor="let condition of getConditions(i)" [value]="condition">
						{{ condition }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!-- value input -->
			<mat-form-field class="filter" appearance="outline" *ngIf="!isConditionEmpty(i) && !isCustomField(i)">
				<mat-label>Value</mat-label>
				<input matInput [type]="getValueType(i)" [placeholder]="getValuePlaceholder(i)" [(ngModel)]="!isConditionIsBetween(i) ? filter.value : filter.rangeValue[0]" (input)="onChangeValue($event, i)" (keyup.enter)="onValueFieldEnter($event, i)" />
			</mat-form-field>

			<mat-form-field class="filter" appearance="outline" *ngIf="!isConditionEmpty(i) && !isCustomField(i) && isConditionIsBetween(i)">
				<mat-label>Value</mat-label>
				<input matInput [type]="getValueType(i)" [placeholder]="getValuePlaceholder(i)" [(ngModel)]="filter.rangeValue[1]" (input)="onChangeValue($event, i, true)" />
			</mat-form-field>

			<!-- select -->
			<mat-form-field class="filter" appearance="outline" *ngIf="!isConditionEmpty(i) && filter.field === 'select'">
				<mat-label>Value</mat-label>
				<mat-select placeholder="Select value" (selectionChange)="onChangeValue($event.value, i)" [value]="filter.value">
					<mat-option *ngFor="let option of getFilterOptions(filter.parameter.key)" [value]="!isOptionString(option) ? option.value : option">
						{{ !isOptionString(option) ? option.label : option }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!-- toggle switch -->
			<mat-slide-toggle *ngIf="!isConditionEmpty(i) && filter.field === 'toggle'" [(ngModel)]="filter.value" (toggleChange)="onChangeValue(!filter.value, i)">
				{{ filter.parameter.text + ': ' + (!filter.value ? 'False' : 'True') }}
			</mat-slide-toggle>

			<!-- autocomplete multiselect -->
			<portals-multiselect-autocomplete class="filter" *ngIf="!isConditionEmpty(i) && filter.field === 'multiselect'" [placeholder]="getValuePlaceholder(i)" [fieldLabel]="'Value'" [selectedData]="filter.rangeValue" [data]="getFilterOptions(filter.parameter.key)" [entityName]="getMultiselectEntityName(filter.parameter.key)" [fieldName]="getMultiselectFieldName(filter.parameter.key)" (onValueChange)="onChangeCustomFieldValue($event, i)"></portals-multiselect-autocomplete>

			<!-- duration picker -->
			<portals-duration-picker *ngIf="!isConditionEmpty(i) && filter.field === 'duration'" [isRange]="isConditionIsBetween(i)" [value]="+filter.value" [rangeValue]="[+filter.rangeValue[0] || 0, +filter.rangeValue[1] || 0]" (onValueChange)="onChangeCustomFieldValue($event, i)"></portals-duration-picker>

			<!-- location picker -->
			<portals-map-autocomplete *ngIf="!isConditionEmpty(i) && filter.field === 'location'" (onValueChange)="onChangeCustomFieldValue($event, i)"></portals-map-autocomplete>

			<!-- moment picker -->
			<portals-moment-filter-autocomplete *ngIf="!isConditionEmpty(i) && filter.field === 'moment'" [selectedTypes]="filter?.subValue || []" [selectedNames]="filter.rangeValue" (onValueChange)="onChangeCustomFieldValue($event, i)" [entityName]="'moment'"></portals-moment-filter-autocomplete>

			<!-- async filter  -->
			<portals-async-filter-autocomplete *ngIf="!isConditionEmpty(i) && filter.field === 'async-dropdown'" [selectedData]="filter.rangeValue" [entityName]="fieldNameCheck[filter.parameter.key].entityName" (onValueChange)="onChangeCustomFieldValue($event, i)" [fieldName]="fieldNameCheck[filter.parameter.key].fieldName" [placeholder]="getValuePlaceholder(i)"></portals-async-filter-autocomplete>
			<button [disableRipple]="true" mat-flat-button class="delete-button" (click)="removeFilter(i)">
				<fa-icon icon="trash" style="font-size: 13px; margin-right: 5px; color: var(--portals-theme-primary-button)"></fa-icon>
			</button>
		</div>
	</div>

	<div class="footer-actions">
		<div>
			<button [disableRipple]="true" class="add" mat-flat-button (click)="addFilter()" style="background: var(--portals-theme-accent-button); color: var(--portals-theme-on-accent-button)">
				<fa-icon mat-flat-button icon="plus" style="font-size: 12px; margin-right: 5px"></fa-icon>
				Add filter
			</button>
			<button
				[disableRipple]="true"
				class="add"
				mat-button
				[ngStyle]="{
					color: app == 'Y-Stop' ? 'var(--portals-theme-accent)' : 'var(--portals-theme-primary)'
				}"
				(click)="clearFilters()"
				style="margin-left: 5px"
			>
				<fa-icon icon="trash" style="font-size: 12px; margin-right: 5px; color: var(--portals-theme-primary-button)"></fa-icon>
				Clear All
			</button>
		</div>

		<button [disableRipple]="true" mat-flat-button [disabled]="isSaveDisabled()" (click)="applyFilters()" style="background: var(--portals-theme-primary-button); color: var(--portals-theme-on-primary-button)">Apply</button>
	</div>
</div>
